import { Component, OnInit, Input, Output, EventEmitter, TemplateRef, inject } from '@angular/core';
import { IInputList } from '../../models';
import { UntypedFormGroup, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'lib-radio-list',
  templateUrl: './radio-list.component.html',
  imports: [FormsModule, ReactiveFormsModule],
})
export class RadioListComponent extends FieldType implements OnInit {
  private readonly fb = inject(FormBuilder);

  @Input() list!: IInputList[];
  @Input() value: any;
  @Input() name = 'radio-list';
  @Output() valueChange = new EventEmitter();
  radioListForm!: UntypedFormGroup;

  ngOnInit(): void {
    this.radioListForm = this.fb.group({
      radioInput: this.value,
    });
  }

  trackByFn(index: any) {
    return index;
  }

  onChange(key: any) {
    this.value = key;
    this.valueChange.next(key);
  }

  isTemplate(item: string | TemplateRef<any>) {
    return item instanceof TemplateRef;
  }
}
